import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// BLANK PAGE
const LearningDashboardPage = lazy(() => import('src/pages/dashboard/mylearning/learning-dashboard'));
const PlayerPage = lazy(() => import('src/pages/dashboard/mylearning/player'));
const CoursesViewPage = lazy(() => import('src/pages/dashboard/mylearning/courses-view'));
const CourseDetailViewPage = lazy(() => import('src/pages/dashboard/mylearning/course-detail-view'));
// LMS
const LmsViewPage = lazy(() => import('src/pages/dashboard/lms/view'));
// STUDENT EXAMINATION
const StudentExaminationListPage = lazy(() => import('src/pages/dashboard/tests/list'));
const ReattemptPage = lazy(() => import('src/sections/reattempts/reattempt-page'));
const ReattemptAnalysis = lazy(() => import('src/sections/reattempts/reattempt-analysis'));
// STUDENT PROFILE  
const StudentProfile = lazy(() => import('src/pages/dashboard/student-profile/profile'));
// SECHDULE 
const SchedulePage = lazy(() => import('src/pages/dashboard/schedule/list'));
// EXAM RESULTS 
const StudentExaminationResultListPage = lazy(() => import('src/pages/dashboard/test-results/list'));
const TestResultProfilePage = lazy(() => import('src/pages/dashboard/test-results/profile'));

// ATTENDANCE
const AttendancePage = lazy(() => import('src/pages/dashboard/attendance'));
// PARENT FEE LIST
const ParentFeeListPage = lazy(() => import('src/pages/dashboard/fee-parent/list'));
// STUDENT FEE LIST
const StudentFeeListPage = lazy(() => import('src/pages/dashboard/fee-student/list'));
const StudentFeeCreatePage = lazy(() => import('src/pages/dashboard/fee-student/new'));
const StudentPayFeePage = lazy(() => import('src/pages/dashboard/fee-student/pay-fee'));
const HostelMessFeeCreatePage = lazy(() => import('src/pages/dashboard/student-profile/collect'));
const StudentTimeTableViewPage = lazy(() => import('src/pages/dashboard/student-timetable/timetableviewpage'));

// REPORTS
const TestResultReportPage = lazy(() => import('src/pages/dashboard/reports-student/test-result-report'));
const QuizSubjectMarksReportPage = lazy(() => import('src/pages/dashboard/reports-student/quiz-subject-marks-report'));
const QuesWiseAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-student/question-wise-analysis-report'));
const StudentTestAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-student/student-test-analysis-report'));
const StudentQuesWiseAnalysisReportPage = lazy(() => import('src/pages/dashboard/reports-student/student-question-wise-analysis-report'));
const StudentReportCardPage = lazy(() => import('src/pages/dashboard/reports-student/student-report-card-report'));
const TaskListPage = lazy(() => import('src/pages/dashboard/task-student/list'));
const StudentStudyMaterialPage = lazy(() => import('src/pages/dashboard/student-study-material'));
// ----------------------------------------------------------------------

export const studentdashboardRoutes = [
  {
    path: 'studentdashboard',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['admin', 'academic', 'student']} hasContent>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <StudentProfile />, index: true },
      { path: 'reattempt', element: <ReattemptPage /> },
      { path: 'study-material', element: <StudentStudyMaterialPage /> },
      { path: 'reattempt/:attemptId', element: <ReattemptAnalysis /> },
      {
        path: 'mylearning',
        children: [
          { element: <LearningDashboardPage />, index: true },
          { path: 'player/:courseId', element: <PlayerPage /> },
          { path: 'courses-view', element: <CoursesViewPage /> },
          { path: 'courses-view/:courseId', element: <CourseDetailViewPage /> },
        ],
      },
      {
        path: 'fee',
        children: [
          { element: <StudentFeeCreatePage />, index: true },

          { path: ':id/collect', element: <StudentFeeCreatePage /> },

        ],
      },
          {
        path: 'hostel',
        children: [
          { element: <HostelMessFeeCreatePage />, index: true },

          { path: ':id/collect', element: <HostelMessFeeCreatePage /> },

        ],
      },
         {
        path: 'mess',
        children: [
          { element: <HostelMessFeeCreatePage />, index: true },

          { path: ':id/collect', element: <HostelMessFeeCreatePage /> },

        ],
      },
        {
        path: 'studenttimetable',
        children: [
          { element: <StudentTimeTableViewPage />, index: true },
          { path: 'list', element: <StudentTimeTableViewPage /> },
        
          
        ],
      },
      {
        path: 'lms',
        children: [{ element: <LmsViewPage />, index: true }],
      },
      {
        path: 'studentexamination',
        children: [
          { element: <StudentExaminationListPage />, index: true },
        ],
      },
      {
        path: 'studentprofile',
        children: [{ element: < StudentProfile />, index: true }],
      },
      {
        path: 'schedule',
        children: [{ element: <SchedulePage />, index: true }],
      },
      {
        path: 'examinationresult',
        children: [
          { element: <StudentExaminationResultListPage />, index: true },
          { path: ':id/profile', element: <TestResultProfilePage /> },
        ],
      },
      { path: 'attendance', element: <AttendancePage /> },
      { path: 'feeparent', element: <ParentFeeListPage /> },
      { path: 'feestudent', element: <StudentFeeListPage /> },
      { path: 'payfee', element: <StudentPayFeePage /> },
      
      {
        path: 'examinationresult',
        children: [
          { element: <StudentExaminationResultListPage />, index: true },
          { path: ':id/profile', element: <TestResultProfilePage /> },
        ],
      },
      { path: ':id/collect/', element: <StudentFeeCreatePage /> },
      {
        path: 'feestudentcollect',
        children: [
          { element: <StudentFeeListPage />, index: true },
          { path: ':id/collect', element: <StudentFeeListPage /> },
        ],
      },
      {
        path: 'testresultreport',
        children: [
          { element: <TestResultReportPage />, index: true },
          { path: 'list', element: <TestResultReportPage /> },
        ],
      },
      {
        path: 'quizsubjectmarksreport',
        children: [
          { element: <QuizSubjectMarksReportPage />, index: true },
          { path: 'list', element: <QuizSubjectMarksReportPage /> },
        ],
      },
      {
        path: 'queswiseanalysis',
        children: [
          { element: <QuesWiseAnalysisReportPage />, index: true },
          { path: 'list', element: <QuesWiseAnalysisReportPage /> },
        ],
      },
      {
        path: 'studenttestanalysis',
        children: [
          { element: <StudentTestAnalysisReportPage />, index: true },
          { path: 'list', element: <StudentTestAnalysisReportPage /> },
        ],
      },
      {
        path: 'studentqueswiseanalysis',
        children: [
          { element: <StudentQuesWiseAnalysisReportPage />, index: true },
          { path: 'list', element: <StudentQuesWiseAnalysisReportPage /> },
        ],
      },
      {
        path: 'studentreportcard',
        children: [
          { element: <StudentReportCardPage />, index: true },
          { path: 'list', element: <StudentReportCardPage /> },
        ],
      },
      {
        path: 'task',
        children: [
          { element: <TaskListPage />, index: true },
          { path: 'list', element: <TaskListPage /> },
        ],
      },
    ],
  },
];
